const APP_NAME = "User Tasks";
const COLOR_MAP = {
  blue: "#2d4d77",
  red: "#c61800",
  gray: "#d4d4d4",
  green: "#4caf50",
};

const USER_TASK_STATUS_MAP = {
  DEFAULT: { color: "orange", label: "Unknown" },
  COMPLETE: { color: "green", label: "Complete" },
  COMPLETED: { color: "green", label: "Completed" },
  CREATED: { color: "orange", label: "Created" },
  WONT_COMPLETE: { color: "purple", label: "Won't Complete" },
  CANCELLED: { color: "red", label: "Canceled" },
  IN_PROGRESS: { color: "blue", label: "In Progress" },
};

export { APP_NAME, COLOR_MAP, USER_TASK_STATUS_MAP };
